import clsxLib from 'clsx';

// export clsx from our package so that consumers of design lib don't have to install it
export type { ClassArray, ClassDictionary, ClassValue } from 'clsx';
export const clsx = clsxLib;
